import { render } from "./DetailPostOrder.vue?vue&type=template&id=887800ae"
import script from "./DetailPostOrder.vue?vue&type=script&lang=js"
export * from "./DetailPostOrder.vue?vue&type=script&lang=js"

import "./DetailPostOrder.vue?vue&type=style&index=0&id=887800ae&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__